/**
 * Replaces common emojis with a space and cleans up multiple spaces
 * We stick to 'safe' emoji ranges so we don't strip out any symbols we wish to keep
 *
 * Before: "Price £100 😀👍🏽 🏳️‍🌈 Hello🌍World🚀 ©2025™ Registered®"
 * After: "Price £100 Hello World ©2025™ Registered®"
 *
 * @param {string} str - The string to remove emojis from
 * @returns {string} - The string with emojis removed
 */
export default function removeEmoji(str) {
  const emoticons = '[\u{1F600}-\u{1F64F}]'; // faces, emotions
  const pictographs = '[\u{1F300}-\u{1F5FF}]'; // nature, food, activities
  const transport = '[\u{1F680}-\u{1F6FF}]'; // vehicles, transport, places
  const pictographs2 = '[\u{1F900}-\u{1F9FF}]'; // hands, people, objects
  const pictographs3 = '[\u{1FA70}-\u{1FAFF}]'; // extended pictographs (ninja, etc.)
  const skinTones = '[\u{1F3FB}-\u{1F3FF}]'; // skin tone modifiers

  // Flags (pair of regional indicators)
  const flags = '\uD83C[\uDDE6-\uDDFF]\uD83C[\uDDE6-\uDDFF]';

  // BMP symbols commonly treated as emoji
  const miscSymbols = '[\u2600-\u26FF]'; // ☀☂☕ etc.
  const dingbats = '[\u2700-\u27BF]'; // ✂✈✔ etc.
  const stars = '[\u2B50-\u2B55]'; // ★,⭕ etc.

  // Emoji glue: ZWJ, VS16/VS15, keycap joiner
  const joiners = '[\u200D\uFE0E\uFE0F\u20E3]';

  // Combine into one regex
  const emojiRegex = new RegExp(
    [
      emoticons,
      pictographs,
      transport,
      pictographs2,
      pictographs3,
      skinTones,
      flags,
      miscSymbols,
      dingbats,
      stars,
      joiners
    ].join('|'),
    'gu'
  );

  return str.replace(emojiRegex, ' ').replace(/ +/g, ' ').trim();
}
